// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { SalesPost } from '../../../../types/server/modules/sales/post';

export type * from '../../../../types/server/modules/sales/post';

export const createPost = ( requests: Requests ): SalesPost => ({
  crm_force_sync_questions: Object.assign(( params, body,headers ) => {
      return requests.post( `/crm/:connectorId/force-sync-questions`, { ...params, body }, headers );
    }, { operation: 'sales:crm-force-sync-questions', route: 'POST /crm/:connectorId/force-sync-questions', subdomain: 'sales', visibility: 'private' } as const )
});
